import AbstractColumn from './AbstractColumn'

export default class SelectColumn extends AbstractColumn {
  constructor (field, mapper) {
    super()
    this.init(field)
    this.htmlType = 'select'
    this.mapper = mapper
    this.options = []
    this.hasMultiple = false
    this.linkedFields = []
  }

  withOptions (options) {
    this.options = options
    return this
  }

  withUpdateOnChange (linkedFields) {
    this.linkedFields = linkedFields
    return this
  }
}
